// Thumbnail generator for Buffington Homes products

// Reusable filename sanitizer
export function sanitizeFilename(name) {
  // Windows + Unix illegal characters:  \ / : * ? " < > |
  // Also trim whitespace to avoid ugly surprises
  return String(name)
    .replace(/[\\\/:*?"<>|]/g, " ") 
    .trim();
}

/**
 * Generate thumbnail URL for a product
 * 
 * @param {number} id - Product ID
 * @param {string} specifier - Product specifier
 * @param {string} size - Image size (default: "256")
 * @param {number} focus - Focus value (default: 500)
 * @param {string} series - Series ID
 * @param {string} name - Product name (for custom thumbs)
 * @param {string} color - Product color (for custom thumbs)
 * @returns {string} Thumbnail URL
 */

export const generateThumbnail = (id, specifier, size = "256", focus = 500, series, name = '', color = '') => {
  const product = {
    id: id,
    specifier: specifier,
    seriesID: series,
    name: name,
    color: color
  };

  // Series that use custom thumbnail files instead of render farm
  const customThumbSeries = [9723, 9724, 9725];
  
  // Check if specifier is an RGB color format like RGB(76,89,72)
  const rgbMatch = product.specifier && product.specifier.match(/^RGB\(\d+,\s*\d+,\s*\d+\)$/i);
  
  let thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}`;
  
  if (customThumbSeries.includes(parseInt(product.seriesID))) {
    const imageName = sanitizeFilename(product.name+"-"+product.color);
    thumbnail = `/thumbs/${product.seriesID}/${imageName}.jpg`;
  }
  // Handle RGB color specifiers
  else if (rgbMatch) {
    const colorSpec = `COLOR(${product.specifier})`;
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${encodeURIComponent(colorSpec)}&type=prod&extra=(focus=${focus})&Size=${size}`;
  }
  // Handle cabinet doors (series 9713)
  else if (product.seriesID == 9713) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&sel=6055643&type=base&extra=(focus=(@SIZE/@IMAGE[1][RES][X]))&Size=250&form=png`;
  }
  // Handle shutter profiles (series 9712)
  else if (product.seriesID == 9712) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&sel=6133437&type=base&extra=(focus=(@SIZE/@IMAGE[1][RES][X]))&Size=250&form=png`;
  }
  // Handle shutter colors (series 9711)
  else if (product.seriesID == 9711) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}`;
  }
  // Handle exterior doors (series 9719)
  else if ([9719].includes(product.seriesID)) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&sel=6076403&size=150&extra=(RX=@apply[1][RES]%7C@image[1][RES],FOCUS=(@size[X]/@RX[X]/1in),size=(Y=(@size[X]*@RX[Y]/@RX[X])))`;
  }
  else if(product.seriesID == 9719){
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&sel=6076395&size=150&extra=(RX=@apply[1][RES]%7C@image[1][RES],FOCUS=(@size[X]/@RX[X]/1in),size=(Y=(@size[X]*@RX[Y]/@RX[X])))`;
  }


  return thumbnail;
};
